export const getNotificationMessage = state =>
  state.notification.content.message;
export const getNotificationDescription = state =>
  state.notification.content.description;
export const getNotificationType = state => state.notification.content.type;
